import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYoastComponent } from './simple-icons-yoast.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYoastComponent ],
    exports:      [ SimpleIconsYoastComponent ],
    bootstrap:    []
})
export class SimpleIconsYoastModule {}
